export const getPaymentDescriptorId = (
  provider: string,
  method?: string,
): string => (method ? `${provider}-${method}` : provider);
